import React from 'react';
import Slider from 'react-slick';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import * as actions from '../../../actions/productData';
import { selectProductSize } from '../../actions/cart';
import { addToCart as addProductToCart } from '../../../actions/addProductToCart';
import { sendEvent } from '../../../utils/dataGrinch.js';
import { getPageInfo } from '../../../utils/pageInfo.js';
import cleverTapPushEvent from '../../../modules/ajio-util/cleverTap/eventUtils';
import CLEVERTAP_EVENT_NAMES from '../../../modules/ajio-util/cleverTap/eventConstants';
import { fetchSizeAndBrandSize, beautyCheck } from '../../../utils/StandardSizeUtils';
import { gtmEventPush, luxeGtmAddToCart } from '../../../modules/ga/GTMdatalayer';
import { jioAdsAddtoCart } from '../../../utils/jioAds';
import { extractRange, manageSizeName } from '../../../utils/sizeConstants';

class EditSizeUpdate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tooltipValue: '',
      brandSize: ''
    };
  }

  componentDidMount() {
    const {
      code,
      wishlistPage = false,
      sizeVariantOptions = [],
      closePopup = _noop,
      newSizeRevampFlag,
      hideSizes,
      updateData
    } = this.props;
    if (code && !wishlistPage) {
      this.props.getProductSize(code);
    }
    if (_get(sizeVariantOptions, 'length') === 1) {
      const productCode = _get(sizeVariantOptions, '[0].code');
      const variantOptionQualifiers = _get(sizeVariantOptions, '[0].variantOptionQualifiers');
      let sizeName;
      variantOptionQualifiers.forEach(size => {
        if (size.qualifier === 'size') {
          sizeName = size.value;
        }
      });
      const { valueWithUnit: beauty } = beautyCheck(variantOptionQualifiers, true);
      const { Size = '' } = fetchSizeAndBrandSize(variantOptionQualifiers, newSizeRevampFlag);
      const value = beauty || Size || sizeName;
      this.setProductSize(undefined, productCode, value);
      if (updateData) {
        updateData({
          key: 'hideSizes',
          value: hideSizes
        });
      }

      if (wishlistPage) {
        closePopup();
      }
    }
  }

  handleLuxeGtmEvents = (selectedSizeCode = '') => {
    const {
      entity: {
        baseProduct: productCode = '',
        code,
        brickCategory,
        brickName,
        exclusiveTill,
        fnlColorVariantData: { color: productColor = '', productTag = '', brandName = '' } = {},
        price: { value } = {},
        wasPriceData: { value: price = '' } = {},
        name,
        discountPercent = '',
        segmentId = '',
        experimentId = ''
      } = {},
      //   selectedSizeCode,
      newDesignLuxe,
      screenName,
      screenType
    } = this.props;
    const tag = exclusiveTill ? 'Exclusive' : '';
    if (newDesignLuxe) {
      luxeGtmAddToCart(
        name,
        code?.split('_')[0],
        value,
        brandName,
        brickCategory,
        selectedSizeCode,
        code?.split('_')[1],
        discountPercent,
        brickName,
        tag,
        1,
        screenName,
        'luxe',
        screenType,
        screenName,
        screenName,
        'luxe',
        true,
        '',
        segmentId,
        experimentId,
        price,
        '',
        '',
        '',
        '',
        selectedSizeCode
      );
    }
  };

  setProductSize = (
    e,
    code,
    value,
    tooltipValue = '',
    priceDataFormattedValue = '',
    brandSizeUI = '',
    selectedSizeCode
  ) => {
    const { wishlistPage = false, updateData = '', entity = {} } = this.props;
    const { 
      variantOptions,
      commercialType = ''
    } = entity || {};
    let deviceType = 'desktop';
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ) {
      deviceType = 'mobile';
    }
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (wishlistPage) {
      const eventObj = [];
      const { pageId, pageType } = getPageInfo(location.pathname || '');
      eventObj.pageId = pageId;
      eventObj.pageType = pageType;

      eventObj.productId = code;
      eventObj.size = value;
      eventObj.Quantity = 1;
      eventObj.Price = priceDataFormattedValue;
      sendEvent('AddToBagFromCloset', eventObj);
      this.handleLuxeGtmEvents(selectedSizeCode || code);

      let batchId;
      if (_get(variantOptions, 'length') > 0) {
        const sizeVariantOptionsArr = variantOptions.filter(variant => variant.code === code);
        const variantOptionQualifiers = _get(sizeVariantOptionsArr, '[0].variantOptionQualifiers');
        variantOptionQualifiers.forEach(variant => {
          if (variant.qualifier === 'imsBatchId') {
            batchId = variant.value;
          }
        });
      }
      console.log("TRACK COMMERICAL TYPE ~ commercialType:", commercialType)
      if (batchId || commercialType) {
        this.props.addProductToCart(code, deviceType, '', '', batchId, commercialType);
      } else {
        this.props.addProductToCart(code, deviceType);
      }
      const {
        entity: { productCode, brickCategory, brickSubCategory, brickName, price: { value } = {} } = {}
      } = this.props;
      console.log("TRACK POINT 3 ~ brickSubCategory:", brickSubCategory)
      const addToCartObj = {
        brickCategory,
        brickSubCategory,
        brickName,
        code: productCode,
        price: value,
        quantity: 1
      };
      jioAdsAddtoCart(addToCartObj);
    } else if (!updateData) {
      this.props.setSelectedSizeValue();
      this.props.getProductSize(code);
    }
    if (value) {
      cleverTapPushEvent({
        eventName: CLEVERTAP_EVENT_NAMES.Change_Size,
        eventObj: {
          New_Size: value
        }
      });
    }
    if (updateData) {
      this.props.updateData({
        key: 'sizeExchanged',
        value
      });
    }
    if (updateData) {
      this.props.updateData({
        key: 'sizeCode',
        value: code,
        isRequiredUpdateEDD: false
      });
    }
    this.setState({ tooltipValue, brandSize: brandSizeUI, successMessage: "Item successfully added to cart." });
  };

  render() {
    const {
      sizeVariantOptions = [],
      getProductSize,
      size: selectedSize,
      sizeToolTip = '',
      pageType = '',
      newSizeRevampFlag,
      showBrandSizeFlag,
      hideSizes,
      wishlistPage = false,
      newDesignLuxe
    } = this.props;
    const { brandSize = '' } = this.state;
    let sizeSwatchVariant;
    let sizeVariant;
    let sizeName;
    let sizeStyle = 'circle';
    let selectedSizeCode = '';
    let selectedBrandSize = '';
    const arr = [];
    const arrTooltip = [];
    if (hideSizes) {
      return null;
    }
    const filterBySize = size => {
      let flag = false;
      if (size.qualifier === 'size' && !flag) {
        sizeName = size.value;
      } else if (size.qualifier === 'standardSize' && size.value) {
        sizeName = size.value;
        flag = true;
      }
    };
    if (sizeToolTip) {
      sizeToolTip.forEach((sizeDataObj, index) => {
        let attrCounter = 0;
        let prodDesc = '';
        let spDesc = '';
        let tooltipHeading = '';
        let tooltipFlag = false;
        let unitAttr = '"';
        let noOfAtrrToShow = 2;

        if (
          !'Show_Tool_Tip' in sizeDataObj ||
          ('Show_Tool_Tip' in sizeDataObj &&
            sizeDataObj.Show_Tool_Tip.toUpperCase() != 'NO' &&
            sizeDataObj.Show_Tool_Tip != '0')
        ) {
          Object.keys(sizeDataObj).forEach(function(s_value, index) {
            if ('Show_Tool_Tip' in sizeDataObj && sizeDataObj.Show_Tool_Tip.toUpperCase() != 'NO') {
              const { Show_Tool_Tip } = sizeDataObj;
              noOfAtrrToShow = Show_Tool_Tip;
            }
            if ('MEASUREMENT_UNIT' in sizeDataObj) {
              if (sizeDataObj.MEASUREMENT_UNIT == 0) {
                unitAttr = '';
              } else if (sizeDataObj.MEASUREMENT_UNIT == 1) {
                unitAttr = ' cm';
              }
            }
            if (s_value.toUpperCase().indexOf('_ATTRIBUTE') >= 0 && attrCounter < noOfAtrrToShow) {
              attrCounter++;
              prodDesc = prodDesc.concat(
                `${s_value.split('_')[0]}-${sizeDataObj[s_value]}${unitAttr}  |  `
              );
            }
            if (s_value.toUpperCase() == 'DESCRIPTION') {
              spDesc = sizeDataObj[s_value].toLowerCase();
            }
            if (s_value.toUpperCase() == 'TOOLTIP_TITLE') {
              tooltipFlag = true;
              tooltipHeading = sizeDataObj[s_value];
            } else if (s_value.toUpperCase() == 'MEASUREMENT_TYPE' && tooltipFlag == false) {
              tooltipHeading = sizeDataObj[s_value];
            }
          });
          prodDesc = prodDesc.substring(0, prodDesc.lastIndexOf('|'));
          arrTooltip.push({
            id: index,
            prodDesc,
            tooltipHeading,
            spDesc,
            sizeName: sizeDataObj.SIZE_NAME
          });
        }
      });
    }
    sizeVariantOptions.forEach((size, i) => {
      const {
        code,
        stock = {},
        variantOptionQualifiers = [],
        priceData: { formattedValue: priceDataFormattedValue = '' } = {}
      } = size;
      const { stockLevelStatus, stockLevel } = stock;
      const filteredSize = variantOptionQualifiers.filter(filterBySize);
      const { valueWithUnit: beauty } = beautyCheck(variantOptionQualifiers, true);
      const { brandSizeUI = '', Size = '' } = fetchSizeAndBrandSize(
        variantOptionQualifiers,
        newSizeRevampFlag
      );
      const checkSize = beauty || Size || sizeName;
      arr.push({
        code,
        stockLevelStatus,
        stockLevel,
        value: checkSize,
        brandSizeUI,
        priceDataFormattedValue,
        sizeAriaLabel : manageSizeName(checkSize) ? manageSizeName(checkSize) : (extractRange(checkSize) ? extractRange(checkSize) : checkSize)
      });
    });

    if (wishlistPage && arr.length) {
      const OOSSizes = arr.reduce((result, eachValue) => {
        if (eachValue.stockLevel === 0) {
          result.push(eachValue.value);
        }
        return result;
      }, []);
      gtmEventPush({
        event: 'add_to_cart_from_closet',
        event_category: 'closet interaction',
        event_action: 'add to cart',
        event_label: _get(sizeVariantOptions, '[0].code'),
        out_of_stock_sizes: OOSSizes.join(),
        out_of_stock_sizes_count: OOSSizes.length
      });
      

    }

    if (arr.length) {
      sizeVariant = arr.map((size, i) => {
        const {
          value,
          code,
          stockLevelStatus,
          stockLevel,
          priceDataFormattedValue,
          brandSizeUI
        } = size;
        const filteredTooltip =
          arrTooltip.filter(function(toolTipItem) {
            return toolTipItem.sizeName == value;
          })[0] || {};
        let toolTipString = '';
        if (filteredTooltip.sizeName !== undefined) {
          toolTipString = `${filteredTooltip.tooltipHeading} (${filteredTooltip.sizeName}) : ${filteredTooltip.prodDesc}${filteredTooltip.spDesc}`;
        }
        if (value.length >= 4) {
          sizeStyle = 'oval';
        }
        if (selectedSize === value) {
          selectedSizeCode = 'selected';
          selectedBrandSize = brandSizeUI;
        } else if (selectedSize === code) {
          selectedSizeCode = 'selected';
          selectedBrandSize = brandSizeUI;
        } else {
          selectedSizeCode = '';
        }
        return (
          <div key={i} className="size-swatch">
            {stockLevelStatus !== 'outOfStock' &&
              stockLevel > 0 &&
              filteredTooltip.sizeName !== undefined &&
              pageType === 'desktop' && (
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement="top"
                  id={i}
                  overlay={
                    <Popover id={i}>
                      <div className="size-tooltip">
                        <div className="tooltip-heading">
                          {filteredTooltip.tooltipHeading} ({filteredTooltip.sizeName})
                        </div>
                        <div className="tooltip-description">{filteredTooltip.prodDesc}</div>
                        <div className="tooltip-info">{filteredTooltip.spDesc}</div>
                      </div>
                    </Popover>
                  }
                >
                  <div
                    className={`${sizeStyle} size-variant-item ${
                      newDesignLuxe ? 'luxe-size-instock' : 'size-instock'
                    } ${selectedSizeCode}`}
                    tabIndex={0}
                    role="button"
                    onClick={e =>
                      this.setProductSize(
                        e,
                        code,
                        value,
                        toolTipString,
                        priceDataFormattedValue,
                        selectedBrandSize
                      )
                    }
                    aria-label={size.sizeAriaLabel}
                  >
                    {value}
                  </div>
                </OverlayTrigger>
              )}
            {stockLevelStatus !== 'outOfStock' &&
              stockLevel > 0 &&
              (filteredTooltip.sizeName === undefined || pageType === 'msite' || !pageType) && (
                <div
                  className={`${sizeStyle} size-variant-item ${
                    newDesignLuxe ? 'luxe-size-instock' : 'size-instock'
                  } ${selectedSizeCode}`}
                  tabIndex={0}
                  role="radio"
                  aria-checked={selectedSizeCode=='selected'}
                  onClick={e =>
                    this.setProductSize(
                      e,
                      code,
                      value,
                      toolTipString,
                      priceDataFormattedValue,
                      selectedBrandSize
                    )
                  }
                  aria-label={size.sizeAriaLabel}
                >
                  {value}
                </div>
              )}
            {(stockLevelStatus === 'outOfStock' || stockLevel == 0) && (
              <div
                className={`${sizeStyle} swatch-size-oos size-variant-item ${
                  newDesignLuxe ? 'luxe-sprite-img' : 'sprite-img'
                }`}
                aria-label={size.sizeAriaLabel}
              >
                {value}
              </div>
            )}
          </div>
        );
      });
    }
    let slickSettings = {
      dots: false,
      infinite: false,
      slidesToShow: 5.5,
      slidesToScroll: 1,
      arrows: true,
      autoplay: false,
      className: 'size-swatch-slick'
    };
    if (sizeStyle === 'oval') {
      slickSettings = {
        dots: false,
        infinite: false,
        slidesToShow: 2.5,
        slidesToScroll: 2,
        arrows: true,
        autoplay: false,
        className: 'size-swatch-slick oval'
      };
    }

    if (sizeVariantOptions.length > 5 || (sizeStyle === 'oval' && sizeVariantOptions.length > 2)) {
      sizeSwatchVariant = (
        <Slider {...slickSettings} ref="slick">
          {sizeVariant}
        </Slider>
      );
    } else {
      sizeSwatchVariant = sizeVariant;
    }
    const brandSizeText = showBrandSizeFlag ? selectedBrandSize : '';
    const { successMessage } = this.state;
    return (
      <div className="size-variant-block" id="size-variant-block">
        <div
          role="alert"
          aria-live="assertive"
          className="sr-only"
        >
          {successMessage}
        </div>
        <div className="size-variant-section" role="radiogroup" aria-labelledby="size-group-label">
          <span id="size-group-label" className="sr-only">
            Select size
          </span>
          {sizeSwatchVariant}
        </div>
        {pageType === 'msite' && this.state.tooltipValue && (
          <div className="size-details-tip">{this.state.tooltipValue}</div>
        )}
        {brandSizeText ? (
          <div className="brand-size-block">
            Brand Size <span className="brand-size-color">{brandSizeText}</span>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProductSize: size => dispatch(selectProductSize(size)),
    addProductToCart: (productId, deviceType, isRecursivelyCalling, successCallback, imsBatchId, commercialType) =>
      dispatch(
        addProductToCart(productId, deviceType, isRecursivelyCalling, successCallback, imsBatchId, commercialType)
      )
  };
};

export default EditSizeUpdate = connect(null, mapDispatchToProps)(EditSizeUpdate);
